import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MarqueeText.vue?vue&type=style&index=0&id=7b78b268&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/Users/cpollhammer/Documents/Projekte/EvodiaAutGithub/vue-marquee-text-component/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__